import { Navigate, Outlet } from 'react-router-dom';
import useAuth from './shared/useAuth';

const AdminOrHRRoute = () => {
    const { userRole } = useAuth();

    const isAdminOrHR = ['admin', 'hr', 'manager', 'superadmin'].includes(userRole);

    if (!isAdminOrHR) {
        return <Navigate to="/dashboard" />;
    }

    return <Outlet />;
};

export default AdminOrHRRoute;